import { Download, Eye, Trash2, Inbox, ScanEye, ArrowUpDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatDate, formatMedia } from "@/components/admin/shared";
import { StatusControls, STATUS_LABELS, STATUS_STYLES } from "@/components/admin/applications/StatusControls";

const SortHead = ({ field, sort, onSort, children }) => (
  <TableHead>
    <button onClick={() => onSort(field)} className={`inline-flex items-center gap-1 hover:text-navy ${sort.field === field ? "text-navy" : ""}`} data-testid={`sort-${field}`}>
      {children} <ArrowUpDown className="h-3 w-3" />
      {sort.field === field && <span className="text-[10px]">{sort.order === "desc" ? "▼" : "▲"}</span>}
    </button>
  </TableHead>
);

const IconButton = ({ onClick, testid, label, hover, icon: Icon }) => (
  <button onClick={onClick} className={`p-2 text-slate-500 transition-colors ${hover}`} data-testid={testid} aria-label={label} title={label}>
    <Icon className="h-4 w-4" />
  </button>
);

const ApplicationRow = ({ a, actions }) => (
  <TableRow data-testid={`application-row-${a.id}`}>
    <TableCell className="whitespace-nowrap text-xs text-slate-500">{formatDate(a.created_at)}</TableCell>
    <TableCell className="font-medium text-navy">{a.nome}</TableCell>
    <TableCell className="hidden md:table-cell text-xs text-slate-500">
      <a href={`mailto:${a.email}`} className="block hover:text-navy">{a.email}</a>
      <a href={`tel:${a.telefono}`} className="block hover:text-navy">{a.telefono}</a>
    </TableCell>
    <TableCell className="hidden lg:table-cell text-xs">{a.universita}</TableCell>
    <TableCell className="hidden lg:table-cell text-xs">{a.tipologia}</TableCell>
    <TableCell>
      <span className={`font-serif text-lg ${a.media >= 27 ? "text-emerald-700" : "text-navy"}`} data-testid={`media-${a.id}`}>{formatMedia(a.media)}</span>
    </TableCell>
    <TableCell>
      <Badge variant="outline" className={STATUS_STYLES[a.status] || ""} data-testid={`app-status-badge-${a.id}`}>{STATUS_LABELS[a.status] || a.status}</Badge>
    </TableCell>
    <TableCell className="text-right">
      <div className="inline-flex items-center gap-1">
        <StatusControls app={a} onChange={actions.changeStatus} />
        <IconButton onClick={() => actions.preview(a)} testid={`preview-cv-${a.id}`} label="Anteprima CV" hover="hover:text-navy" icon={ScanEye} />
        <IconButton onClick={() => actions.download(a)} testid={`download-cv-${a.id}`} label="Scarica CV" hover="hover:text-navy" icon={Download} />
        <IconButton onClick={() => actions.view(a)} testid={`view-application-${a.id}`} label="Dettagli" hover="hover:text-gold-dark" icon={Eye} />
        <IconButton onClick={() => actions.remove(a.id)} testid={`delete-application-${a.id}`} label="Elimina" hover="hover:text-red-600" icon={Trash2} />
      </div>
    </TableCell>
  </TableRow>
);

export const ApplicationsTable = ({ apps, loading, sort, onSort, actions }) => (
  <div className="mt-6 border border-navy/10 bg-white" data-testid="admin-applications-table">
    <Table>
      <TableHeader>
        <TableRow>
          <SortHead field="created_at" sort={sort} onSort={onSort}>Data Invio</SortHead>
          <TableHead>Nome e Cognome</TableHead>
          <TableHead className="hidden md:table-cell">Contatti</TableHead>
          <TableHead className="hidden lg:table-cell">Università</TableHead>
          <TableHead className="hidden lg:table-cell">Tipologia</TableHead>
          <SortHead field="media" sort={sort} onSort={onSort}>Media</SortHead>
          <TableHead>Stato</TableHead>
          <TableHead className="text-right">Azioni</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {loading ? (
          <TableRow><TableCell colSpan={8} className="py-10 text-center text-slate-500">Caricamento...</TableCell></TableRow>
        ) : apps.length === 0 ? (
          <TableRow><TableCell colSpan={8} className="py-12 text-center text-slate-500"><Inbox className="mx-auto mb-3 h-8 w-8 text-slate-300" />Nessuna candidatura presente</TableCell></TableRow>
        ) : (
          apps.map((a) => <ApplicationRow key={a.id} a={a} actions={actions} />)
        )}
      </TableBody>
    </Table>
  </div>
);
